import * as jose from 'jose';
import * as api from './api';

import { SW_MESSAGE_TYPE } from './utils/enum';
import { STORAGE_KEYS, Storage } from './utils/store';
import AuthGuard from './core/auth/auth-guard';

/**
 * Authentifie un utilisateur avec son login et son mdp
 */
export function login() {
    //TODO: A SUPPRImer - seulement pour assurer monter de version
    localStorage.removeItem('accident_type');
    localStorage.removeItem('activity');
    localStorage.removeItem('pathology');

    const usernameField = document.getElementById('username');
    const passwordField = document.getElementById('password');
    const button = document.getElementById('login');
    const spinner = document.getElementById('spinner');

    const username = usernameField.value;
    const password = passwordField.value;

    usernameField.disabled = true;
    passwordField.disabled = true;
    button.style.display = 'none';
    spinner.classList.add('active');

    AuthGuard.login(username, password).finally(() => {
        button.style.display = 'inherit';
        spinner.classList.remove('active');
        usernameField.disabled = false;
        passwordField.disabled = false;
    });
}

export function logout() {
    AuthGuard.logout();
    
    navigator.serviceWorker.ready.then(registration => {
        registration.active.postMessage({type: SW_MESSAGE_TYPE.WS_DISCONNECT});
    });
}
